import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { PublicFormIntakeService } from '../services/public-form-intake.service';
import { PublicFormShortLinkService } from '../services/public-form-short-link.service';

export const publicFormShortUrlGuard: CanActivateFn = async (route) => {
  const router = inject(Router);
  const intake = inject(PublicFormIntakeService);
  const shortLink = inject(PublicFormShortLinkService);

  const raw = route.paramMap.get('shortId')?.trim();
  if (!raw) {
    return router.createUrlTree(['/form-unavailable']);
  }

  try {
    await intake.verifyShortUrl(raw);
    shortLink.setShortUrlDocId(raw);
    return true;
  } catch {
    return router.createUrlTree(['/form-unavailable']);
  }
};
